import RespuestaService from 'src/modules/respuesta/respuestaService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';

const prefix = 'RESPUESTA_FORM';

const respuestaFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: respuestaFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await RespuestaService.find(id);
      }

      dispatch({
        type: respuestaFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: respuestaFormActions.INIT_ERROR,
      });

      getHistory().push('/respuesta');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: respuestaFormActions.CREATE_STARTED,
      });

      await RespuestaService.create(values);

      dispatch({
        type: respuestaFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.respuesta.create.success'),
      );

      getHistory().push('/respuesta');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: respuestaFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: respuestaFormActions.UPDATE_STARTED,
      });

      await RespuestaService.update(id, values);

      dispatch({
        type: respuestaFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.respuesta.update.success'),
      );

      getHistory().push('/respuesta');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: respuestaFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default respuestaFormActions;
